import { render, staticRenderFns } from "./GreenFactory.vue?vue&type=template&id=79ffd262&scoped=true&"
import script from "./GreenFactory.vue?vue&type=script&lang=js&"
export * from "./GreenFactory.vue?vue&type=script&lang=js&"
import style0 from "./GreenFactory.vue?vue&type=style&index=0&id=79ffd262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ffd262",
  null
  
)

export default component.exports